/**
 * Initiate OAuth2 authorization flow
 * Redirects user to IAM API authorize endpoint
 */
export function initiateLogin(
  tenantSlug: string,
  appSlug?: string,
  returnUrl?: string
): void {
  // Build authorize URL
  const params = new URLSearchParams();

  if (appSlug) {
    params.set('application', appSlug);
  } else if (returnUrl) {
    params.set('application', returnUrl);
  }
  
  const query = params.toString();
  const authorizeUrl = `/auth/federations/${tenantSlug}/login${query ? `?${query}` : ''}`;
  
  // Redirect to IAM authorize endpoint
  window.location.href = authorizeUrl;
}

/**
 * Get tenant slug from URL or use default
 * Supports patterns like: /t/{tenant-slug} or query param ?tenant=...
 */
export function getTenantSlugFromUrl(): string | null {
  // Check URL path: /t/{tenant-slug}
  const pathMatch = window.location.pathname.match(/^\/t\/([^\/]+)/);
  if (pathMatch) {
    return pathMatch[1];
  }
  
  // Check query parameter: ?tenant=...
  const params = new URLSearchParams(window.location.search);
  const tenantParam = params.get('tenant');
  if (tenantParam) {
    return tenantParam;
  }
  
  // No tenant specified
  return null;
}
